import EmitenteService from "@/services/EmitenteService";

export const emitente = {
  namespaced: true,
  state: {
    emitente: {},
  },
  actions: {
    getEmitente({ commit }, payload) {
      return EmitenteService.GetEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEmitente({ commit }, payload) {
      return EmitenteService.PostEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEmitente({ commit }, payload) {
      return EmitenteService.PutEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEmitente({ commit }, payload) {
      return EmitenteService.DeleteEmitente(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteOData({ commit }, payload) {
      return EmitenteService.GetEmitenteOData(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    postRegisterEmitente({ commit }, payload) {
      return EmitenteService.PostRegisterEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default emitente;
